import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Newspaper, Mail, Bell, UserPlus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

export default function AdminDashboard({ stats, isAdmin, setActiveTab }) {
  const navigate = useNavigate();

  return (
    <div data-testid="dashboard-tab">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <Card className="border-0 shadow-lg">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div><p className="text-sm text-zinc-500">Événements</p><p className="text-3xl font-bold text-zinc-900">{stats.events || 0}</p></div>
              <Calendar className="h-10 w-10 text-fuchsia-600 opacity-50" />
            </div>
          </CardContent>
        </Card>
        <Card className="border-0 shadow-lg">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div><p className="text-sm text-zinc-500">Actualités</p><p className="text-3xl font-bold text-zinc-900">{stats.news || 0}</p></div>
              <Newspaper className="h-10 w-10 text-lime-600 opacity-50" />
            </div>
          </CardContent>
        </Card>
        <Card className="border-0 shadow-lg">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div><p className="text-sm text-zinc-500">Abonnés Newsletter</p><p className="text-3xl font-bold text-zinc-900">{stats.subscribers || 0}</p></div>
              <Mail className="h-10 w-10 text-indigo-600 opacity-50" />
            </div>
          </CardContent>
        </Card>
      </div>
      <Card className="border-0 shadow-lg">
        <CardHeader><CardTitle>Actions Rapides</CardTitle></CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Button variant="outline" className="h-auto py-4 flex-col" onClick={() => navigate('/actualites')}><Newspaper className="h-6 w-6 mb-2" />Gérer Actualités</Button>
            <Button variant="outline" className="h-auto py-4 flex-col" onClick={() => navigate('/evenements')}><Calendar className="h-6 w-6 mb-2" />Voir Événements</Button>
            <Button variant="outline" className="h-auto py-4 flex-col" onClick={() => setActiveTab('releases')}><Bell className="h-6 w-6 mb-2" />Nouvelle Release</Button>
            {isAdmin && <Button variant="outline" className="h-auto py-4 flex-col" onClick={() => setActiveTab('users')}><UserPlus className="h-6 w-6 mb-2" />Ajouter Utilisateur</Button>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
